<div class="defect-item">
  <div class="defect-item-header">
    <status-point [background]="item.category"></status-point>
    <span class="defect-item-name" (click)="editFailure()">{{ index + 1 }}. {{ item.name }}</span>
  </div>
  <span>
    <span>{{ getItemCodes(item) }}
    </span><ng-container *ngIf="item.description">| {{ item.description }}</ng-container>
    <ng-container *ngIf="showDate && item.createdOn">| {{ formatDate(item.createdOn) }}</ng-container>
  </span>
  <div *ngIf="!last" class="defect-item-divider"></div>
</div>
